

/* 
GLOBAL LOGIC HANDLER OF DROPDOWN (SELECT)
USAGE:




USED IN: {sorting-dropdown.liquid}



*/

class SortDropdown {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.button = wrapper.querySelector('.select-dropdown-button');
    this.content = wrapper.querySelector('.select-dropdown-content');
    this.valueSpan = wrapper.querySelector('.selected-value');
    this.hiddenInput = wrapper.querySelector('input[type="hidden"]');
    this.options = wrapper.querySelectorAll('.select-option');
    this.svg = this.button.querySelector('svg');
    
    this.init();
  }

  init() {
    this.button.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleDropdown();
    });

    this.options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        this.selectOption(option);
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.wrapper.contains(e.target)) {
        this.closeDropdown();
      }
    });

    this.updateFromURL();
  }

  toggleDropdown() {
    this.content.classList.toggle('show');
    this.svg.classList.toggle('rotated');
  }

  closeDropdown() {
    this.content.classList.remove('show');
    this.svg.classList.remove('rotated');
  }

  selectOption(option) {
    const value = option.getAttribute('data-value');
    const text = option.textContent;
    const defaultValue = this.hiddenInput.getAttribute('data-default-sortby');

    this.valueSpan.textContent = text;
    this.hiddenInput.value = value;
    this.closeDropdown();

    this.options.forEach(opt => opt.classList.remove('selected'));
    option.classList.add('selected');

    const url = new URL(window.location);
    value === defaultValue ? url.searchParams.delete('sort_by') : url.searchParams.set('sort_by', value);
    window.location.href = url.toString();
  }

  updateFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    // The default is the collection's own (data-default-sortby), never a literal best-selling:
    // that sort is no longer offered anywhere (owner request 2026-10-03).
    const sortParam = urlParams.get('sort_by') || this.hiddenInput.getAttribute('data-default-sortby') || '';
    if (!sortParam) return;
    
    // The URL value is user input: match it against each option's data-value instead of
    // interpolating it into a CSS selector (an unexpected value threw a SyntaxError here).
    const selectedOption = Array.from(this.options).find(opt => opt.getAttribute('data-value') === sortParam) || null;
    if (selectedOption) {
      this.valueSpan.textContent = selectedOption.textContent;
      this.hiddenInput.value = sortParam;
      this.options.forEach(opt => opt.classList.remove('selected'));
      selectedOption.classList.add('selected');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ia-select-component').forEach(wrapper => {
    new SortDropdown(wrapper);
  });
});